import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { DAILY_ACTIVITIES } from "@/data/onboarding-topics";
import { cn } from "@/lib/utils";

interface DailyLifeStepProps {
  selected: string[];
  onToggle: (slug: string) => void;
  onContinue: () => void;
  onBack: () => void;
}

export function DailyLifeStep({
  selected,
  onToggle,
  onContinue,
  onBack,
}: DailyLifeStepProps) {
  return (
    <div className="flex flex-col items-center text-center gap-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          What's your daily life like?
        </h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Select all that apply — we'll prioritize relevant vocabulary
        </p>
      </div>

      <div className="w-full max-w-sm flex flex-wrap justify-center gap-2">
        {DAILY_ACTIVITIES.map((item) => {
          const isSelected = selected.includes(item.slug);
          return (
            <motion.button
              key={item.slug}
              whileTap={{ scale: 0.95 }}
              onClick={() => onToggle(item.slug)}
              className={cn(
                "px-3 py-2 rounded-full border text-sm font-medium transition-colors",
                isSelected
                  ? "border-blue-500 bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-400"
                  : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:border-gray-600"
              )}
            >
              {item.emoji} {item.label}
            </motion.button>
          );
        })}
      </div>

      <div className="flex gap-3 w-full max-w-sm">
        <Button variant="outline" onClick={onBack} size="lg">
          <ChevronLeft className="w-4 h-4 mr-1" />
          Back
        </Button>
        <Button
          onClick={onContinue}
          className="flex-1"
          size="lg"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
